import { Controller } from "@hotwired/stimulus"
import { parseNumber, formatNumber } from "../helpers"

// Pojedynczy wiersz pozycji rozliczenia KSeF (obciążenie/odliczenie) — usuwanie i formatowanie
export default class extends Controller {
  static targets = ["destroyField", "amount", "currencyLabel"]
  static values = { maxAmount: Number, locale: String, currency: String }

  remove() {
    if (this.hasDestroyFieldTarget) {
      // istniejący rekord — soft-ukryj i oznacz do usunięcia
      this.destroyFieldTarget.value = "1"
      this.element.classList.add("hidden")
    } else {
      // nowy rekord (jeszcze niezapisany) — usuń z DOM
      this.element.remove()
    }
  }

  restoreIfMarkedForDestroy() {
    if (this.hasDestroyFieldTarget && this.destroyFieldTarget.value === "1") {
      this.destroyFieldTarget.value = "0"
      this.element.classList.remove("hidden")
    }
  }

  formatAmount() {
    const input = this.amountTarget
    let val = parseNumber(input.value, { locale: this.localeValue })
    if (isNaN(val) || val < 0) { input.value = ""; return }
    if (val > this.maxAmountValue) val = this.maxAmountValue
    input.value = formatNumber(val, { locale: this.localeValue, app_digits: 2 })
  }

  currencyValueChanged(value) {
    if (this.hasCurrencyLabelTarget) this.currencyLabelTarget.textContent = value
  }
}
